import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const DescribedListItem = styled.div`
  display: grid;
  grid-template-rows: 20px auto;
  grid-template-columns: 24px auto;
  grid-column-gap: 12px;
`;

export const Image = styled.img`
    grid-column-start: 1;
    grid-column-end: 1;
    grid-row-start: 1;
    grid-row-end: 2;
`;

export const Title = styled.div`
    grid-column-start: 2;
    grid-row-start: 1;

    ${FONTS.XS};
    color: ${COLORS.TextHint};
    white-space: nowrap;

    @media (max-width: ${wideBreakpoints.mobile}) {
      ${FONTS.XXS};
    }
`;

export const Text = styled.span`
    grid-column-start: 2;
    grid-row-start: 2;

    ${FONTS.S};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.mobile}) {
      ${FONTS.XS};
    }
`;
